<template>
    <div>
        <v-card-text
            style="height: 400px;display: flex;flex-direction: column;"
        >
            <div>
                <v-text-field
                    v-model="search"
                    :label="`Search for a template...`"
                    solo
                    append-icon="search"
                    hide-details
                    :loading="searching"
                    autofocus
                    @keyup="handleKeypress"
                    ref="searchinput"
                />
            </div>
            <div
                v-if="formTemplates.length > 0 || (case_type && case_type.templates.length !== 0 && !search)"
                style="flex-grow: 1;overflow-y: auto;overflow-x:hidden;"
            >
                <div
                    v-if="case_type && case_type.templates.length !== 0 && !search"
                >
                    <div
                        style="font-weight: 700;text-align:center;padding: 10px;font-size: 16px;"
                    >
                        Select a Template below from the {{ case_type.name }} Case Type, or start typing to search
                    </div>
                    <div
                        v-for="ft in case_type.templates"
                        :key="ft.id"
                        style="padding: 10px;transition: all 0.5s;cursor:pointer;margin: 5px;"
                        :class="{'selected': selected == ft.id}"
                        class="ft-o"
                        @click="selected = ft.id"
                    >
                        {{ ft.name }}
                    </div>
                </div>
                <div
                    v-else
                >
                    <div
                        v-for="ft in formTemplates"
                        :key="ft.id"
                        style="padding: 10px;transition: all 0.5s;cursor:pointer;margin: 5px;"
                        :class="{'selected': selected == ft.id}"
                        class="ft-o"
                        @click="selected = ft.id"
                    >
                        {{ ft.name }}
                    </div>
                </div>
            </div>
            <div
                v-else
                style="flex-grow: 1;display:flex;align-items: center;align-content: center;flex-direction: column;justify-content: center"
            >
                <v-icon
                    size="64"
                >
                    mdi-magnify
                </v-icon>
                <div
                    v-if="search"
                    style="padding: 15px;"
                >
                    <b>No Results for {{ search }}</b>
                </div>
                <div
                    v-if="!search"
                    style="padding: 15px;"
                >
                    <b>Start Typing to Search</b>
                </div>
            </div>
        </v-card-text>
    </div>
</template>

<script>
import api from '@/api'

export default {
    props: ['caseType'],
    data () {
      return {
        selected: null,
        formTemplates: [],
        searching: false,
        search: '',
        case_type: null
      }
    },
    watch: {
        selected () {
            this.$emit('select', this.selected)
        }
    },
    created () {
        if (this.caseType)
            this.fetchCaseType()
    },
    methods: {
        handleKeypress (e) {
            let charCode = (e.which) ? e.which : e.keyCode
            switch (charCode) {
                case 40:
                    this.focusUp()
                    break;
                case 38:
                    this.focusDown()
                    break;
                case 13:
                    this.$emit('confirm')
                    break;
                case 27:
                    this.$emit('cancel')
                    break;
                default:
                    this.loadFormTemplates()
            }
        },
        loadFormTemplates () {
            this.searching = true
            api.formtemplate.formtemplate.list({ search: this.search, count: 15 })
                .then(data => {
                    this.searching = false
                    this.formTemplates = data.results
                    if (this.formTemplates.length > 0)
                        this.selected = this.formTemplates[0].id
                    else
                        this.selected = null
                })
        },
        fetchCaseType () {
            this.searching = true
            api.cases.casetype.get(this.caseType)
                .then(data => {
                    this.searching = false
                    this.case_type = data
                })
        },
        focusUp () {
            if (this.formTemplates.length == 0)
                return
            if (this.selected) {
                var idx = this.formTemplates.findIndex((e) => e.id == this.selected)
                if (idx != this.formTemplates.length - 1)
                    this.selected = this.formTemplates[idx + 1].id
            } else {
                this.selected = this.formTemplates[0].id
            }
        },
        focusDown () {
            if (this.formTemplates.length == 0)
                return
            if (this.selected) {
                var idx = this.formTemplates.findIndex((e) => e.id == this.selected)
                if (idx != 0)
                    this.selected = this.formTemplates[idx - 1].id
            } else {
                this.selected = this.formTemplates[0].id
            }
        },
        focusInput() {
            this.$refs.searchinput.$el.focus()
        }
    }
}
</script>

<style scoped>
    .selected {
        border-radius: 5px;
    }

    .ft-o {
        
    }
    .ft-o:hover {
        background: rgba(0,0,0,0.05)
    }
</style>